import React from "react";
import CctDetails from "../../components/editors/CctDetails";
import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "../../navigations/RootNavigation";
import { useI18n } from "../../hooks/i18n-hooks";
import ScreenHeader from "./ScreenHeader";

type Props = StackScreenProps<RootStackParamList, "CctDetails">;

const CctDetailsScreen: React.FC<Props> = ({ route, navigation }) => {
    const i18n = useI18n();

    return (
        <>
            <ScreenHeader
                useSmallLabel
                onLeftAction="back"
                label={i18n.t("screens.cct_details.title")}
                hideProfile
            ></ScreenHeader>
            <CctDetails {...route.params} navigation={navigation} />
        </>
    );
};

export default CctDetailsScreen;
